// extracted by mini-css-extract-plugin
export default {"button":"ku","primary":"lu","fullWidth":"mu","secondary":"nu","nutrition":"ou","underlined":"pu","small":"qu","medium":"ru","info":"su","white":"tu","border":"uu","mango":"vu","charcoal":"wu","court":"xu","green":"yu","spark":"zu","linkButton":"Au","disabled":"Bu"};
    if(module.hot) {
      // 1738836192850
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  